import PSY_URI from '@/assets/Utils/api/url-const'
import { GET ,POST } from '@/assets/Utils/api/http';


/*
*  官网视频类别列表
*  @param{
*  }
* */
export const GetVideoCategoryList =()=>{
  return GET(PSY_URI.VIDEO_CATEGORY_LIST)
}


